import { render, staticRenderFns } from "./generalLedger.vue?vue&type=template&id=614d1d8e"
import script from "./generalLedger.vue?vue&type=script&lang=js"
export * from "./generalLedger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports